import React from 'react';
import {Col, Row} from "antd";
import {useGetExchangesQuery} from "../services/cryptoAPI";

function Exchanges() {
    const {data, isFetching} = useGetExchangesQuery;
    const exchangeList = data?.data?.exchanges;


    return (
        <>
        <Row>
            <Col span={6}>Exchanges</Col>
            <Col span={6}>Exchanges</Col>
            <Col span={6}>Exchanges</Col>
            <Col span={6}>Exchanges</Col>
        </Row>
        </>
    );
}

export default Exchanges;